import { IngestedOrdersMetrics } from '@model/ingested-order/ingested-order.model';
import { OrdersMetricsBackendResponse } from '../api/ingested-orders-api.interface';

/**
 * Mapper for transforming order metrics between backend DTOs and domain models
 * Handles both ADMITTED and RECEIVED metric responses
 */
export class IngestedOrdersMetricsMapper {
  /**
   * Transforms backend DTO to domain model
   * Handles both ADMITTED (without reprocesses) and RECEIVED (with reprocesses) responses
   *
   * @param dto - Backend response DTO
   * @returns Domain model with metrics data
   *
   * @example
   * // ADMITTED response
   * const dto = { totalOrders: 14, ordersToday: 14 };
   * const result = IngestedOrdersMetricsMapper.toDomain(dto);
   * // { totalOrders: 14, ordersToday: 14 }
   *
   * @example
   * // RECEIVED response
   * const dto = { totalOrders: 26, ordersToday: 26, reprocesses: 5 };
   * const result = IngestedOrdersMetricsMapper.toDomain(dto);
   * // { totalOrders: 26, ordersToday: 26, reprocesses: 5 }
   */
  static toDomain(dto: OrdersMetricsBackendResponse): IngestedOrdersMetrics {
    const metrics: IngestedOrdersMetrics = {
      totalOrders: dto.totalOrders,
      ordersToday: dto.ordersToday
    };

    // Only include reprocesses if present in DTO (RECEIVED status)
    if ('reprocesses' in dto && dto.reprocesses !== undefined) {
      metrics.reprocesses = dto.reprocesses;
    }

    return metrics;
  }
}
